import {
  isMobileScreenWidth,
  isNotMobileScreenWidth,
  isAtPWA,
} from 'dashboard/helper/zimobi/responsivenessHelper';

export default {
  data() {
    return {
      screenWidth: window.innerWidth,
    };
  },
  computed: {
    isAtMobile() {
      return isMobileScreenWidth(this.screenWidth);
    },
    isNotAtMobile() {
      return isNotMobileScreenWidth(this.screenWidth);
    },
    isAtMobilePWA() {
      return isAtPWA() && this.isAtMobile;
    },
  },
  created() {
    window.addEventListener('resize', this.updateWidth);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateWidth);
  },
  methods: {
    updateWidth() {
      this.screenWidth = window.innerWidth;
    },
  },
};
